import { AppService } from "app/services/app.service";

import { Configuracoes } from "app/models/configuracoes.model";
import { Observable } from "rxjs";
import { CodigoPreCadastroAction } from "enums/codigo-pre-cadastro-action.enum";
import { CodigoPreCadastroResponse } from "app/models/codigo-pre-cadastro-response.model";

export abstract class AbConfiguracoes extends AppService {
  abstract KEY_CONFIGURACOES: string;
  abstract getConfiguracoes(): Observable<any>;
  abstract getReloadConfiguracoes(): Observable<any>;
  abstract salvarConfiguracaoNoStorage(cfg: Observable<any>);
  abstract getZoneId(idTimezone);
  abstract salvarTimeZoneNoStorage(tz: string);
  abstract saveConfiguracoes(configuracoes: Configuracoes): Observable<any>;
  abstract getTimeZones(config: string): Observable<any>;
  abstract getOneTimeZone(id: number): Observable<any>;
  abstract putAtivarNovoModelo(): Observable<any>;
  abstract putAcaoCodigoCadastro(acao: CodigoPreCadastroAction): Observable<CodigoPreCadastroResponse>;
  abstract getStatusCodigoPreCadastro(integradorUuidOrId: string): Observable<{codigoPreCadastroAtivo:boolean}>;
}
